export const TRUSTED_DOMAINS = [
  'linkedin.com',
  'twitter.com',
  'facebook.com',
  'youtube.com',
  'instagram.com',
  'pinterest.com',
  'tiktok.com',
  'snapchat.com',
  'reddit.com',
  'tumblr.com',
  'whatsapp.com',
  'vimeo.com',
  'flickr.com',
  'quora.com',
  'yelp.com',
  'tripadvisor'
];
